import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-content">
                <p>&copy; {new Date().getFullYear()} Zimmerei Felix Herzberg</p>
                <Link to="/impressum" className="footer-link">Impressum</Link>
            </div>
        </footer>
    );
}

export default Footer; 